import { render, staticRenderFns } from "./stars.vue?vue&type=template&id=9cb8d328&scoped=true&"
import script from "./stars.vue?vue&type=script&lang=js&"
export * from "./stars.vue?vue&type=script&lang=js&"
import style0 from "./stars.vue?vue&type=style&index=0&id=9cb8d328&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cb8d328",
  null
  
)

export default component.exports